/**
 * AppInfoBus — observer des changements d'app active (extrait de WebPage, ha/443d).
 *
 * Maintient une Map de subscribers (subscriptionId → callback). WebPage y délègue
 * subscribeToAppInfo / unsubscribeToAppInfo / notifyAppInfo. Comportement
 * strictement identique au God-object d'origine :
 *  - l'id de souscription encode l'appId courant + un timestamp,
 *  - `subscribe` renvoie le couple [appId, subscriptionId],
 *  - `notify` court-circuite si aucun watcher (préserve l'early-return legacy).
 *
 * L'appId courant est fourni par l'appelant (WebPage connaît `currAppId`) ; le
 * bus ne dépend donc d'aucun état de navigation.
 */
export class AppInfoBus {
    private readonly watchers = new Map<string, (info: Map<string, any>) => void>();

    public subscribe(func: (info: Map<string, any>) => void, appId: string): string[] {
        const subscriptionId: string = appId + "_" + Date.now();
        this.watchers.set(subscriptionId, func);
        return [appId, subscriptionId];
    }

    public unsubscribe(subscriptionId: string): void {
        this.watchers.delete(subscriptionId);
    }

    public notify(info: Map<string, any>): void {
        if (this.watchers.size < 1) { return; }
        this.watchers.forEach((func) => func(info));
    }

    public size(): number {
        return this.watchers.size;
    }
}
